var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"s-canvas"},[_c('img',{staticClass:"verify-image",attrs:{"width":"160","height":"50","id":"verify-image","src":_vm.verifyCode,"type":"image/png","alt":"Verify"},on:{"click":_vm.CallLoginRefreshCode}})])])}
var staticRenderFns = []

export { render, staticRenderFns }